<template>
    <transition name="fade-bottom" mode="out-in">
        <div v-if="isVisible" class="mb-3" :class="portletclass">
            <b-accordion class="nesting-accordion custom-accordionwithicon"  id="commonPortletAccordionWrap">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="accordionnestingComPortlet">
                        <button class="accordion-button fs-5" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accor_nestingPortlet" :aria-expanded="showCollapse"
                            aria-controls="accor_nestingPortlet">
                            {{ headertitle }}
                        </button>
                    </h2>
                    <div :class="{'show': showCollapse }" id="accor_nestingPortlet" class="accordion-collapse collapse"
                        aria-labelledby="accordionnestingComPortlet" data-bs-parent="#commonPortletAccordionWrap">
                        <div class="accordion-body p-lg-4">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </b-accordion>
        </div>
    </transition>
    </template>
    
    <script>
    export default {
        props: {
            headertitle: {
                type: String,
                default: "Filters"
            },
            portletclass: {
                type: String,
                default: ""
            },
            open:{
                type: Boolean,
                default: false
            },
            visible:{
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                isVisible: this.visible,
                showCollapse: false,
                isLoading: false
            };
        },
        watch: {
            visible (val) {
                this.isVisible = !this.isVisible
            }
        },
        methods: {
            refreshContent() {
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false
                },400)
            },
            remove() {
                this.isVisible = false;
            },
            collapse() {
                this.showCollapse = !this.showCollapse;
            }
        },
        mounted(){
            if(this.open) {this.showCollapse = true}
        }
    };
    </script>
    
    
    <style lang="scss">
    
    </style>